
import { isUserAuthenticated, hasRoles } from '../../utils/refreshCurrentUser';


export default function OnEnterRedirectUnauthorized(store, allowed) {
  return (nextState, replace, done) => {
    isUserAuthenticated(store)
      .then(() => {
        if (!allowed || allowed.length === 0) {
          return done();
        }

        return hasRoles(store, allowed)
                .then(() => done());
      })
      .catch(() => {
        replace('/');
        done(false); // Cancel subsequent hooks if any.
      })
    ;
  }
}

export function OnEnterAllowEmployees(store) {
  return OnEnterRedirectUnauthorized(store, ['Employee']);
}

export function OnEnterAllowClients(store) {
  return OnEnterRedirectUnauthorized(store, ['Client']);
}



// WEBPACK FOOTER //
// ./shared/react/OnEnterHooks/redirectUnauthorized.js